import React, { useEffect, useState } from 'react';
import styles from './NewBookingBlock.module.css';
import { Checkbox, Tooltip } from 'antd';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import BookingsBar from '../BookingsBar/BookingsBar';
import { toast } from 'react-toastify';


const NewBookingBlock = ({ location_id, bookingEndTime, newBookingForm, setNewBookingForm, timeFormatAmPm, bookingNonRes, bookingStartTime, isNightCharging, nightChargeEndTime }) => {

  const [chargers, setChargers] = useState([]);
  const [isChargersLoading, setIsChargersLoading] = useState(false);
  const [chargerAvailable, setChargerAvailable] = useState(false);
  const [nightChargeAvailableConnectorIDs, setNightChargeAvailableConnectorIDs] = useState([])

  const getChargers = async () => {
    try {
      setIsChargersLoading(true);
      const fetchedChargers = await BreathAPIs.getChargerByLocation(location_id, new Date(), null, bookingEndTime);

      if (Array.isArray(fetchedChargers.data.availableConnectors)) {
        let availableConnectors = fetchedChargers.data.availableConnectors.filter(connector => connector.nonReservable === bookingNonRes);
        setChargers(availableConnectors);
        console.log("available connector length: ", availableConnectors.length)

        if(isNightCharging){
                            let connectorIDList = availableConnectors.map((conn)=> conn._id)
                            console.log("connector di list in new booking form: ", connectorIDList)
                            let response = await BreathAPIs.getAvailableNightChargeConnectors(bookingStartTime, nightChargeEndTime, connectorIDList)
                            console.log('respnose for night charge connectos in new booking form: ', response.data)
                            setNightChargeAvailableConnectorIDs(response.data)
                        }
      } else {
        console.error("Fetched chargers data is not an array:", fetchedChargers.data);
      }

      setIsChargersLoading(false);
    } catch (apiError) {
      console.error("API request error:", apiError);
      // You can handle API request errors here, e.g., show a notification to the user
      setIsChargersLoading(false);
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const currentDate = new Date();
    const dateToConvert = new Date(dateString);

    date.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: timeFormatAmPm
    };

    let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);

    if (date.getTime() > currentDate.getTime()) {
      updatedFormat = updatedFormat + (' (+1)');
    }

    return updatedFormat;
  }

  useEffect(() => {
    if (location_id) {
      getChargers();
    }
  }, [location_id]);

  if (isChargersLoading) {
    return (
      <div className="card-body text-center">
        Loading chargers...
        <p className={`card-text placeholder-glow`}><span className="placeholder col-12 rounded"></span> </p>
      </div>
    )
  }


  const updateToBookingForm = (startTime, endTime, charger) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const differenceInMinutes = (end - start) / (1000 * 60);
  
    if (differenceInMinutes > 30) {
      setNewBookingForm({ selectedCharger: charger, selectedFromDate: startTime, selectedToDate: endTime });
    } else {
      toast.error('The selected time slot is too short. Please ensure the booking duration is at least 30 minutes.');
    }
  };
  


  return (
    <div>


      {!newBookingForm?.refundRequest && <>
        <div className={styles['charger-view']}>
          <div>Available Chargers</div>
          <div className={styles['chargers-list']}>
            {console.log("chargers lenght in render: ", chargers.length)}
            {(!isChargersLoading && chargers) && chargers.map((connector) => (
              <div key={connector._id}>
                <BookingsBar
                  timeFormatAmPm={timeFormatAmPm}
                  charger={connector}
                  selectedChargerFeedBack={updateToBookingForm}
                  isSelected={newBookingForm?.selectedCharger?._id === connector._id}
                  haveCharger={()=>{setChargerAvailable(true)}}
                  nightChargeAvailableConnectorIDs={nightChargeAvailableConnectorIDs}
                />
              </div>
            ))}
            {(!isChargersLoading && (chargers.length == 0 || !chargerAvailable)) && <div className='mt-3 text-center mb-3'>No chargers are available.</div>}
          </div>
        </div>



        {newBookingForm?.selectedCharger?._id && <div className={styles['new-booking-block']}>
          <div className={styles['new-booking-item']}>Selected Charger : <b>{newBookingForm?.selectedCharger?.charger.chargerTag} {newBookingForm.selectedCharger?.noOfConnectorsInCharger !== 1 ? ` - #${newBookingForm.selectedCharger?.connectorNumber}` : ""}</b></div>
          <div className={styles['new-booking-item']}>Time : <b>{formatDate(newBookingForm?.selectedFromDate)} - {formatDate(newBookingForm?.selectedToDate)}</b></div>
        </div>}

      </>}

      <Checkbox checked={newBookingForm?.refundRequest} className='mt-2' onChange={(e) => setNewBookingForm({ selectedCharger: null, selectedFromDate: null, selectedToDate: null, refundRequest: e.target.checked })}>Request to refund</Checkbox>


    </div>
  );
};

export default NewBookingBlock;
